import { Grid, Skeleton, styled, Box } from '@mui/material';
import React from 'react';

const PREFIX = 'GeneralSkeleton';
const classes = {
  skeleton: `${PREFIX}-skeleton`,
  skeletonCard: `${PREFIX}-skeletonCard`,
};
const SkeletonGrid = styled(Grid)(({ theme }) => ({
  [`&.${classes.skeleton}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(0),
  },
  [`& .${classes.skeletonCard}`]: {
    width: '100%',
    marginBottom: '1px',
  },
}));

const GenSkeleton = ({
  count = 4,
  variant = 'rectangular',
  height = 72,
  sx,
}) => {
  const arr = new Array(count).fill('').map((_, i) => i + 1);
  return (
    <Box sx={sx}>
      <SkeletonGrid container className={classes.skeleton}>
        {arr.map((e, i) => (
          <Skeleton
            key={i}
            variant={variant}
            className={classes.skeletonCard}
            height={height}
          />
        ))}
      </SkeletonGrid>
    </Box>
  );
};

export default GenSkeleton;
